const stairwellType = Object.freeze({
    STAIRWELL: 'CAGE',
    BUILDING: 'BATIMENT'
});

export default stairwellType;